/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M13.14 12.1h1.9c.63 0 1.14-.5 1.14-1.13V5.65c0-.63-.52-1.13-1.15-1.13H2.14c-.63 0-1.14.5-1.14 1.13v5.32c0 .62.51 1.13 1.14 1.13h1.9v-1.13c0-.63.5-1.14 1.13-1.14h6.84c.62 0 1.13.5 1.13 1.14z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M3.54 4.52h-.5c0 .27.22.5.5.5zm1 0v.5a.5.5 0 0 0 .5-.5zm8.1 0h-.5c0 .27.22.5.5.5zm1 0v.5a.5.5 0 0 0 .5-.5zm-.5 7.58h-.5c0 .28.22.5.5.5zm.5 0h.5a.5.5 0 0 0-.5-.5zm-1-2.08.28-.41a.5.5 0 0 0-.78.41zm-8.1 0h.5a.5.5 0 0 0-.79-.41zm-.5 2.08v.5a.5.5 0 0 0 .5-.5zm-.5 0v-.5a.5.5 0 0 0-.5.5zm.5-7.62a3 3 0 0 1 3-3v-1a4 4 0 0 0-4 4zm0 .04v-.04h-1v.04zm.5-.5h-1v1h1zm-.5.46v.04h1v-.04zm3-3a3 3 0 0 0-3 3h1c0-1.1.9-2 2-2zm3.1 0h-3.1v1h3.1zm3 3a3 3 0 0 0-3-3v1a2 2 0 0 1 2 2zm0 .04v-.04h-1v.04zm.5-.5h-1v1h1zm-.5.46v.04h1v-.04zm-3-3a3 3 0 0 1 3 3h1a4 4 0 0 0-4-4zm-3.1 0h3.1v-1h-3.1zm6.1 11.12h.5v-1h-.5zm-.5-1.63v1.13h1v-1.13zm-.28-.54q.27.19.28.54h1c0-.57-.29-1.07-.72-1.36zm.78 3.23v-3.64h-1v3.64zm-3 3a3 3 0 0 0 3-3h-1a2 2 0 0 1-2 2zm-3.1 0h3.1v-1h-3.1zm-3-3a3 3 0 0 0 3 3v-1a2 2 0 0 1-2-2zm0-3.64v3.64h1v-3.64zm.5.95q0-.35.28-.53l-.57-.83c-.43.3-.71.8-.71 1.36zm0 1.13v-1.13h-1v1.13zm-1 .5h.5v-1h-.5zm.5 1.06V12.1h-1v1.56zm3 3a3 3 0 0 1-3-3h-1a4 4 0 0 0 4 4zm3.1 0h-3.1v1h3.1zm3-3a3 3 0 0 1-3 3v1a4 4 0 0 0 4-4zm0-1.56v1.56h1V12.1z",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
